import * as React from "react";
import { useSelector } from "react-redux";

const PointsHeader = () => {
  const member = useSelector((state: any) => state.member);

  const points = new Intl.NumberFormat("en-US").format(
    member?.memberPointsTally || 0
  );

  if (member?.isLoggedIn) {
    return (
      <div className="header-points-display">
        <span>{points || 0} points</span>
      </div>
    );
  } else {
    return null;
  }
};

export default PointsHeader;
